import deepmerge from 'deepmerge'

// eslint-disable-next-line max-params
export const overwriteMerge = (destination, source) => source

// Example usage of overwriteMerge:
// const overwrite = deepmerge(
//   { foo: 'bar', array: [1, 2, 3, 5, 6, 88] },
//   { array: [34, 45] },
//   {
//     arrayMerge: overwriteMerge
//   }
// ) // => { foo: 'bar', array: [34, 45]}

const emptyTarget = value => (Array.isArray(value) ? [] : {})
const clone = (value, options) => deepmerge(emptyTarget(value), value, options)

// eslint-disable-next-line max-params
export const combineMerge = (target, source, options) => {
  const destination = target.slice()

  source.forEach((e, i) => {
    if (typeof destination[i] === 'undefined') {
      const cloneRequested = options.clone !== false
      const shouldClone = cloneRequested && options.isMergeableObject(e)
      destination[i] = shouldClone ? clone(e, options) : e
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge(target[i], e, options)
    } else if (target.indexOf(e) === -1) {
      destination.push(e)
    }
  })
  return destination
}

// Example usage of combineMerge:
// const combine = deepmerge(
//   { test: 'hallo', array: [1, 2, 3] },
//   { array: [3, 2, 1, 5] },
//   {
//     arrayMerge: combineMerge
//   }
// ) // => [1, 2, 3, 6]

/**
 * A little helper function that overwrites an element with a specific id in an array containing elements with idProp
 * @param {array} sourceArray - an array that contains an element with a specifig id that should be replaced
 * @param {object} targetElement - the target element with a specific id which should replace the source element with the same id
 * @param {string} idProp - (optional) supply the name of the id prop if it is not 'id' (e.g. sellerId)
 */
export const overwriteElementWithId = (
  sourceArray,
  targetElement,
  idProp = 'id'
  // eslint-disable-next-line max-params
) => {
  const targetArray = sourceArray.map(sourceElement => {
    if (sourceElement[idProp] === targetElement[idProp]) {
      return targetElement
    }
    return sourceElement
  })
  return targetArray
}
